import { Layout } from "@/components/layout/Layout";
import { Hero } from "@/components/home/Hero";
import { SocialProofBar } from "@/components/home/SocialProofBar";
import { AboutRefound } from "@/components/home/AboutRefound";
import { Problem } from "@/components/home/Problem";
import { Features } from "@/components/home/Features";
import { HowItWorks } from "@/components/home/HowItWorks";
import { Retailers } from "@/components/home/Retailers";
import { HomeSolutions } from "@/components/home/HomeSolutions";
import { Testimonials } from "@/components/home/Testimonials";
import { HomeFAQ } from "@/components/home/HomeFAQ";
import { Download } from "@/components/home/Download";
import { HomeSEO } from "@/components/home/HomeSEO";

const Index = () => {
  return (
    <Layout>
      <HomeSEO />
      <Hero />
      <SocialProofBar />
      <Problem />
      <Features />
      <HomeSolutions />
      <HowItWorks />
      <Retailers />
      <Testimonials />
      <AboutRefound />
      <HomeFAQ />
      <Download />
    </Layout>
  );
};

export default Index;
